import { parse, trunc } from '@/utils/date'
import { d } from './options'

export const date = 'yyyy-MM-dd'
export const datetime = `${date} HH:mm:ss`

export function dateDisabledFn (value: string | string[], flag: 'gt' | 'ge' | 'lt' | 'le' | 'in' = 'gt', format: string = datetime) {
  return (date: Date) => {
    if (!value) return false
    if (typeof value === 'string') {
      const targetDate = parse(value, format)
      const ret = trunc(date).getTime() - trunc(targetDate).getTime()
      if (flag === 'gt' && ret > 0) return false
      if (flag === 'ge' && ret >= 0) return false
      if (flag === 'lt' && ret < 0) return false
      if (flag === 'le' && ret <= 0) return false
      return true
    } else {
      const startDate = value[0] ? parse(value[0], format) : null
      const endDate = value[1] ? parse(value[1], format) : null
      const lt = !startDate ? false : (trunc(date).getTime() - trunc(startDate).getTime()) < 0
      const gt = !endDate ? false : (trunc(date).getTime() - trunc(endDate).getTime()) > 0
      return lt || gt
    }
  }
}
